import type { FeatureKey } from '@/hooks/useEntitlements';

/** Persona voice for Desk welcome copy. Setup steps themselves live in `desk_habit_reps`. */
export type DeskVoice = 'seller' | 'broker' | 'buyer';

export function deskVoice(can: (f: FeatureKey) => boolean): DeskVoice {
  if (!can('inventory.manage')) return 'buyer';
  return can('inventory.resell') ? 'broker' : 'seller';
}

/** First-login welcome, in Jhavid's voice: appreciative, unhurried, no tour. */
export const DESK_WELCOME: Record<DeskVoice, { lead: string; body: string }> = {
  seller: {
    lead: 'Awesome — we’re super happy to have you.',
    body: 'Let’s set up your desk together, at your own speed. Bring in your listings, and we’ll help you get them in front of the buyers you already trust.',
  },
  broker: {
    lead: 'Awesome — we’re super happy to have you.',
    body: 'Your suppliers’ inventory and your buyers, together in one quiet place. Step inside and we’ll keep the busywork off your plate.',
  },
  buyer: {
    lead: 'Welcome — glad you’re here.',
    body: 'Every supplier menu you’re invited to lands in one place. Tell us what you’re hunting for and we’ll keep watch while you’re busy.',
  },
};


/** Ready-to-send text for the "text a buyer" handoff. */
export function deskShareSnippet(companyName: string | null, url: string): string {
  const who = companyName ?? 'We';
  return `Hey — ${who} ${companyName ? 'is' : 'are'} now sharing our menus on Cannafax. Grab access here so you see new listings first: ${url}`;
}
